var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiamondAward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 156.979,
    height: 223.372,
    viewBox: "0 0 156.979 223.372",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "diamond-award",
    transform: "translate(-76.09)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29391",
    "data-name": "Group 29391",
    transform: "translate(141.492 128.041)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48997",
    "data-name": "Path 48997",
    d: "M239.088,293.49l13.088,36.093H226V293.49Z",
    transform: "translate(-226 -293.49)",
    fill: "#fb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48998",
    "data-name": "Path 48998",
    d: "M256,293.49h13.088v36.093H256Z",
    transform: "translate(-242.912 -293.49)",
    fill: "#ff8c1a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29392",
    "data-name": "Group 29392",
    transform: "translate(108.601 157.59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48999",
    "data-name": "Path 48999",
    d: "M183.5,361.22a32.928,32.928,0,0,0-32.891,32.891h45.979l13.088-16.445L196.589,361.22Z",
    transform: "translate(-150.61 -361.22)",
    fill: "#fd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49000",
    "data-name": "Path 49000",
    d: "M301.979,394.111H256V361.22h13.088A32.928,32.928,0,0,1,301.979,394.111Z",
    transform: "translate(-210.021 -361.22)",
    fill: "#fb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29393",
    "data-name": "Group 29393",
    transform: "translate(91.32 183.936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49001",
    "data-name": "Path 49001",
    d: "M111,421.609V454.5h63.259l13.088-16.446-13.088-16.445Z",
    transform: "translate(-111 -421.609)",
    fill: "#638293"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49002",
    "data-name": "Path 49002",
    d: "M256,421.609h63.259V454.5H256Z",
    transform: "translate(-192.741 -421.609)",
    fill: "#375363"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29394",
    "data-name": "Group 29394",
    transform: "translate(78.232 210.283)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49003",
    "data-name": "Path 49003",
    d: "M81,482v13.088h76.348l13.088-6.544L157.348,482Z",
    transform: "translate(-81 -482)",
    fill: "#375363"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49004",
    "data-name": "Path 49004",
    d: "M256,482h76.348v13.088H256Z",
    transform: "translate(-179.652 -482)",
    fill: "#1b323a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29399",
    "data-name": "Group 29399",
    transform: "translate(76.09 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29395",
    "data-name": "Group 29395",
    transform: "translate(0 23.406)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49005",
    "data-name": "Path 49005",
    d: "M185.119,97.354,154.58,158.285,76.09,74.914,154.58,53.65Z",
    transform: "translate(-76.09 -53.65)",
    fill: "#aedeed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49006",
    "data-name": "Path 49006",
    d: "M334.49,74.914,256,158.285V53.65Z",
    transform: "translate(-177.51 -53.65)",
    fill: "#62bdcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29396",
    "data-name": "Group 29396",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49007",
    "data-name": "Path 49007",
    d: "M106.372,0,76.09,44.67h47.951L154.58,23.406l4.363-12.518L154.58,0Z",
    transform: "translate(-76.09 0)",
    fill: "#d4f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49008",
    "data-name": "Path 49008",
    d: "M334.49,44.67H286.539L256,23.406V0h48.208Z",
    transform: "translate(-177.51 0)",
    fill: "#aedeed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29397",
    "data-name": "Group 29397",
    transform: "translate(47.951 23.406)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49009",
    "data-name": "Path 49009",
    d: "M186,74.914l30.539,83.372,13.088-74.247L216.539,53.65Z",
    transform: "translate(-186 -53.65)",
    fill: "#d4f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49010",
    "data-name": "Path 49010",
    d: "M256,53.65V158.285l30.539-83.372Z",
    transform: "translate(-225.461 -53.65)",
    fill: "#aedeed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29398",
    "data-name": "Group 29398",
    transform: "translate(47.951 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49011",
    "data-name": "Path 49011",
    d: "M216.539,0,186,44.67h30.539l6.772-10.337Z",
    transform: "translate(-186)",
    fill: "#aedeed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49012",
    "data-name": "Path 49012",
    d: "M256,0V44.67h30.539Z",
    transform: "translate(-225.461)",
    fill: "#62bdcc"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondAward);
export default __webpack_public_path__ + "static/media/diamond_award.f644736dceec76f259fed47392ff13e3.svg";
export { ForwardRef as ReactComponent };